import script from "./FixedPromoMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FixedPromoMessage.vue?vue&type=script&setup=true&lang=ts"

import "./FixedPromoMessage.vue?vue&type=style&index=0&id=37b434a9&lang=scss"

const __exports__ = script;

export default __exports__